import { useEffect, useRef } from 'react'

interface UseAutoCallProps {
    func: () => void
    ms: number
    enabled?: boolean
}

const useAutoCall = ({ func, ms, enabled = true }: UseAutoCallProps) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null)

    useEffect(() => {
        if (enabled) {
            timeoutRef.current = setTimeout(() => {
                func()
            }, ms)
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [func, ms, enabled])

    const cancel = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
        }
    }

    return { cancel }
}

export default useAutoCall
